module.exports = __webpack_public_path__ + "static/img/アセット 59@3x.bc8b72b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/アセット 59@3x.png
// module id = 6aED
// module chunks = 1